import { AbstractControl, ValidatorFn } from '@angular/forms';

export const abnValidator = (): ValidatorFn => {
  return (control: AbstractControl) => {
    if (control.value !== null) {
      const trimmedValue = control.value.replace(/\D+/g, '');
      return !isNaN(Number(trimmedValue)) && trimmedValue.toString().length === 11 ? null : {abn: true}
    }
    return null;
  };
};




// WEBPACK FOOTER //
// ./src/app/shared/validators/abn.validator.ts